import api from 'base/utils/api';
import {
    IAddCartItem,
    ISpuInfo,
    IVariantNum,
    IProductShareTasks,
    ITogetherPrice,
    IAddCartType
} from 'base/interfaces/product';
import type { GetServerSidePropsContext } from 'next';
import { ICompareRes } from 'base/interfaces/product-compare';
import { IProduct, IRecommendListData, ITogether } from 'base/interfaces/product';
import { formatErrors } from 'base/utils/data';
import { getDefaultVariant } from 'mod/product/utils';

// 获取商品详情
export async function getProductSpu(params: {
    variantId?: string;
    productId?: string;
    uri?: string;
    pageFrom?: string;
}): Promise<ISpuInfo> {
    return api.get('/web/product/spuV2', { params }).then(res => {
        const { spuInfo, ...rest } = res;
        return {
            ...rest,
            ...spuInfo,
        }
    });
}

// 搭配商品
export async function getTogetherProducts(params: {
    productId: string,
    variantId: string,
}): Promise<ITogether[]> {
    return api.get('/web/product/spu/together/v5', {
        params: {
            productId: params.productId,
            variantId: params.variantId,
        }
    }).then(res => res.togetherItemList).catch(err => {
        console.log(err);
        return [];
    });
}

// Buy Together 价格计算
export async function calculateTogetherProductsPrices(params: {
    variantId: string,
    togetherVariantIds: string[],
}): Promise<ITogetherPrice> {
    return api.post('/web/cart/buy/together/calculate', {
        data: {
            variantId: params.variantId,
            togetherVariantIds: params.togetherVariantIds,
        }
    }).then(res => res).catch(err => {
        console.log(err);
        return null;
    });
}


// 获取product所有变体的 AddOns
export async function getProductAddOns(params: {
    productId: string;
    variantId: string;
}): Promise<Record<string, IProduct[]>> {
    return api.get('/web/product/addOns', {
        params: {
            productId: params.productId,
            variantId: params.variantId,
        }
    }).then(res => res.addOns);
};

// 添加购物车
export async function postAddCart(
    cartItems: IAddCartItem[],
    addType: IAddCartType = 'defaultAdd',
    deleteItemIds?: string[] // cartItemIds
): Promise<{ addFailProductName: string[] }> {
    return api.post('/web/cart/v2/add', {
        data: {
            cartItems,
            addType,
            deleteItemIds
        }
    });
}

// 推荐商品 you may also like
export async function getProductRecommend(params: {
    variantId: string,
    page: number,
    size: number
}): Promise<IRecommendListData> {
    const { variantId, ...rest } = params
    return api.get(`/web/product/variant/recommend/${variantId}`, {
        params: rest
    })
}


// 对比商品
export async function getCompareData(variantId: string): Promise<ICompareRes> {
    return api.get(`/web/product/spu/compare/${variantId}`)
}

// 添加购物车
export async function getBundleDealsListTips(): Promise<any> {
    return api.get('/web/cart/v2/bundleDealsListTips');
}

// 服务端获取数据
// 访问 http://localhost:3000/en-US/vivosun-mylar-hydroponic-grow-tent-8x8-for-indoor-plant-96x96x80-p63933466594377747-v58820960379609901
// 96x96x80
// 返回 http://localhost:3000/en-US/vivosun-4x4-mylar-hydroponic-grow-tent-for-indoor-plant-growing-48x48x80-p63933466594377747-v58820960379609764
// 48x48x80
export async function getServerSideProps({ params, query, resolvedUrl, req, res }: GetServerSidePropsContext) {
    let path: string | undefined = params?.path as string;
    let uri!: string;
    let variantId!: string;
    let productId!: string;
    const variantIdReg = /.*-v(\d+).*/
    const productIdReg = /.*-p(\d+).*/
    if (variantIdReg.test(path)) {
        variantId = path.replace(variantIdReg, '$1');
    } else if (productIdReg.test(path)) {
        productId = path.replace(productIdReg, '$1');
    } else {
        uri = path;
    }

    const errors: Error[] = [];

    const spu = await getProductSpu({
        variantId,
        productId,
        uri,
    }).catch(err => {
        res.statusCode = err.code >= 200001 && err.code <= 200006 ? 404 : 500;
        errors.push(err);
        return null;
    });

    const shownVariant = spu ? getDefaultVariant(spu) : null;

    return {
        props: errors.length ? { errors: formatErrors(errors) } : {
            ageLimit: spu?.ageLimit,
            spu,
            seo: {
                canonicalUrl: shownVariant?.url || ''
            }
        }
    }
}

export function checkBuyNow(variantNums: Array<IVariantNum>): Promise<null> {
    return api.post('/web/cart/v2/checkGroupValid', {
        data: {
            variantNums
        }
    })
}

export function shareProductFinish(params: {
    variantId: string;
}): Promise<IProductShareTasks> {
    return api.post('/web/share/product/finish', {
        data: params
    })
}
